import { a as __rest } from '../../tslib.es6.esm.js';
import { jsx } from 'react/jsx-runtime';
import React__default from 'react';
import { Title } from '@radix-ui/react-toast';

const ToastTitle = React__default.forwardRef((_a, ref) => {
    var { className, children } = _a, props = __rest(_a, ["className", "children"]);
    return (jsx(Title, Object.assign({ ref: ref, className: className }, props, { children: children })));
});
ToastTitle.displayName = "ToastTitle";

export { ToastTitle };
